<template>
    <div class="redirect">
        <NotFound v-if="NOT_FOUND" />
    </div>
</template>
<script>
import api from '@/api'

import NotFound from '@/views/NotFound'

export default {
    name: 'Redirect',
    components:{NotFound},
    data() {
        return {
            NOT_FOUND: false
        }
    },
    methods: {
        async redirectTo() {
            const id = this.$route.params.id
            const response = await api.get('pages/',{
                type: 'base.RedaPage',
                old_id: id,
                fields:'url'
            })

            if (response.ok) {
                if (response.data.items.length) {
                    this.$router.push(response.data.items[0].url)
                }
            }
            this.NOT_FOUND = true
        }
    },
    mounted () {
        this.redirectTo()

    }
}
</script>